var generateStyle = function generateStyle(componentTheme) {
  return {
    timer: {
      lineHeight: '1rem',
      fontSize: componentTheme.timerFontSize,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    },
    timerLeft: {
      display: 'flex',
      flexDirection: 'column-reverse',
      alignItems: 'center'
    },
    timerRight: {
      padding: componentTheme.timerRightPadding
    },
    timeRemainingLabel: {
      fontSize: componentTheme.timeRemainingLabelFontSize,
      width: '100%',
      textAlign: 'center'
    }
  };
};
export default generateStyle;